'use client';

import React, { useState } from 'react';
import { Button, Row } from '@stape-io/promo-shared-content/components';
import clsx from 'clsx';

import { useClientTranslation } from '@/lib/i18n/client';
import { Article } from '@/lib/models/Articles';
import { ArticleItem } from '@/shared/ArticleItem';
import { HELPDESK_TAGS, HelpdeskModuleTags } from '@/lib/constants/HelpdeskModuleTags';

import styles from './PopularContent.module.scss';

type PopularContentProps = {
  popularArticles: Record<HelpdeskModuleTags, Article[]>;
};

export default function PopularContent({ popularArticles }: PopularContentProps) {
  const [activeTab, setActiveTab] = useState<HelpdeskModuleTags>(HelpdeskModuleTags.knowledgebase);
  const { t } = useClientTranslation('popular');
  const articles = popularArticles[activeTab];

  return (
    <section className={clsx(styles.wrapper, 'text text-sm')}>
      <Row>
        <h3 className={clsx(styles.title, 'h3')}>{t('popular.popularTitle')}</h3>
        <nav className={styles.popularTabs}>
          {HELPDESK_TAGS.map((type) => (
            <Button
              key={type}
              className={clsx(styles.tabItem, 'text text-sm', activeTab === type && [styles.active, 'text-bold'])}
              onClick={() => setActiveTab(type)}
              color="transparent"
            >
              <span className={styles.tabTitle} data-text={t(`popular.${type}Title`)}>
                <span>{t(`popular.${type}Title`)}</span>
              </span>
            </Button>
          ))}
        </nav>
        <div className={styles.popularContent}>
          {articles.map((article) => (
            <ArticleItem type={activeTab} key={article.id} article={article} className="text" />
          ))}
        </div>
      </Row>
    </section>
  );
}
